import { ConvertedComponentData } from '../../../cms/components/types'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'

export interface TrainingDescriptionComponentData extends ConvertedComponentData {
  trainingId?: string;
  hideRegisterButton?: boolean;
}

export const TRAINING_DESCRIPTION_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingDescriptionComponentData>[]>('TrainingDescriptionConverter')
